module.exports = __webpack_public_path__ + "static/media/blue01.538a885b.svg";